export default "__VITE_ASSET__a4b38a97__"